import React, { Children, cloneElement } from 'react';
import classnames from 'classnames';
import { s as styleInject } from './style-inject.es-4a6aca40.js';

var css_248z = ".sunzi_components__icon-1BGku {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  width: 20px;\n  height: 20px;\n}\n.sunzi_components__icon-1BGku > svg {\n  width: 100%;\n  height: 100%;\n  fill: #000;\n}\n";
var styles = {"icon":"sunzi_components__icon-1BGku"};
styleInject(css_248z);

var Icon = function (_a) {
  var children = _a.children,
      className = _a.className,
      color = _a.color,
      size = _a.size,
      onClick = _a.onClick;
  return React.createElement("div", {
    className: classnames(styles.icon, className),
    onClick: onClick,
    style: {
      width: size,
      height: size
    }
  }, Children.map(children, function (child) {
    return cloneElement(child, {
      style: {
        fill: color
      }
    });
  }));
};

export default Icon;
